import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { generatePinSync as generatePin } from 'secure-pin';

import Spinner from 'components/Spinner';
import BaseModal from '../BaseModal';

import styles from './styles.module.scss';

const pin = generatePin(4);

class ActivateSubModal extends Component {
  state = {
    loading: false,
  };

  handleActivate = (values) => {
    const {
      sub,
      activateSub,
      fetchUpcomingPlan,
      findSub,
      successText,
      closeModal,
    } = this.props;

    this.setState({ loading: true });
    return activateSub(sub.id, values)
      .then(() => findSub(sub.id))
      .then(() => {
        if (fetchUpcomingPlan) {
          return fetchUpcomingPlan(sub.id);
        } else {
          return Promise.resolve();
        }
      })
      .then(() => {
        closeModal();
        const successMsg = successText || 'Subcription Activated';
        toast.success(successMsg);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  render() {
    const {
      sub,
      user,
      isOpen,
      closeModal,
      isAtt,
      isAgentOrAdminOrManager,
      ActivateSubModalForm,
    } = this.props;
    const { loading } = this.state;

    const initialValues = isAtt ? { pin, bypass_att: true } : {};

    return (
      <BaseModal
        isOpen={isOpen}
        title="Activate Subscription"
        onClose={closeModal}
        className={styles.modal}
        contentClassName={styles.content}
        confirmBtnText=""
        cancelBtnText=""
      >
        <ActivateSubModalForm
          sub={sub}
          user={user}
          initialValues={initialValues}
          onSubmit={this.handleActivate}
          isAgentOrAdminOrManager={isAgentOrAdminOrManager}
        />
        <Spinner showLoader={loading} />
      </BaseModal>
    );
  }
}

export default ActivateSubModal;
